import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/customer/add/many/tenant.customer.add.many.mutation.gql"
import type {
  TenantCustomerAddManyMutation,
  TenantCustomerAddManyMutationVariables,
} from "@/v2-backoffice-client/tenant/customer/add/many/__types__/tenant.customer.add.many.mutation"

type Options = MutationHookOptions<
  TenantCustomerAddManyMutation,
  TenantCustomerAddManyMutationVariables
>

export function useTenantCustomerAddManyMutation(options?: Options) {
  return useMutation<
    TenantCustomerAddManyMutation,
    TenantCustomerAddManyMutationVariables
  >(mutation, options)
}
